var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 9.99996H18.3337M1.66699 5.83329H5.83366M14.167 5.83329H18.3337M1.66699 14.1666H5.83366M14.167 14.1666H18.3337M5.83366 18.3333V1.66663M14.167 18.3333V1.66663M5.66699 18.3333H14.3337C15.7338 18.3333 16.4339 18.3333 16.9686 18.0608C17.439 17.8211 17.8215 17.4387 18.0612 16.9683C18.3337 16.4335 18.3337 15.7334 18.3337 14.3333V5.66663C18.3337 4.26649 18.3337 3.56643 18.0612 3.03165C17.8215 2.56124 17.439 2.17879 16.9686 1.93911C16.4339 1.66663 15.7338 1.66663 14.3337 1.66663H5.66699C4.26686 1.66663 3.5668 1.66663 3.03202 1.93911C2.56161 2.17879 2.17916 2.56124 1.93948 3.03165C1.66699 3.56643 1.66699 4.26649 1.66699 5.66663V14.3333C1.66699 15.7334 1.66699 16.4335 1.93948 16.9683C2.17916 17.4387 2.56161 17.8211 3.03202 18.0608C3.5668 18.3333 4.26686 18.3333 5.66699 18.3333Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.a658c9b589b59833863c7e5ad94ed4e5.svg";
export { ForwardRef as ReactComponent };